import React from "react";
import Weather from "./Weather";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="New York" />
      </div>
      <a
        href="https://github.com/marthaminash/weather-app-react-shecodes"
        className="openSourceLink"
      >
        Open-source code
      </a>{" "}
      by Martha Minash
    </div>
  );
}

export default App;
